import { render, staticRenderFns } from "./ProductDetailOverall.vue?vue&type=template&id=6c9a5260&"
import script from "./ProductDetailOverall.vue?vue&type=script&lang=js&"
export * from "./ProductDetailOverall.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailOverall.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports